(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

document.addEventListener('DOMContentLoaded', function (e) {
    var orderForm = document.getElementById('dideban-order-status-form');
    var orderResponse = document.getElementById('dideban-order-status-form-response-table');
    var submitButton = document.getElementsByClassName('dideban-form-button')[0];
    submitButton.style.setProperty("background", orderForm.getAttribute("data-color"), "important");

    var didebanTableBackground = document.getElementById('dideban-table-background');
    didebanTableBackground.style.setProperty("background", didebanTableBackground.getAttribute("data-color"), "important");

    function submitFrom() {
        resetMessages();

        var url = orderForm.dataset.url;
        var params = new URLSearchParams(new FormData(orderForm));

        fetch(url, {
            method: "POST",
            body: params
        }).then(function (res) {
            return res.json();
        }).catch(function (error) {
            resetMessages();
            orderForm.querySelector('.js-form-error').classList.add('show');
        }).then(function (response) {
            resetMessages();

            if (response === 0 || response.status === 'error' || !response.status) {
                orderForm.querySelector('.js-form-error').classList.add('show');
                return;
            }
            var color = orderResponse.getAttribute("data-color");

            if (jQuery('#dideban-stepper').length > 0) {
                jQuery("#div-tracking-list").empty();
                response.data.statuses.forEach(function (time) {
                    jQuery("#div-tracking-list").append(createTimeElement(time['time'], time['to_status'], color));
                });
            } else {
                jQuery("#dideban-timeline").empty();
                // var startLine= jQuery("<span>");
                // var li= jQuery("<li>",{"class":"li start-line"}).append(startLine);
                // jQuery("#dideban-timeline").append(li);
                var didebanHorizontalTimeline = document.getElementById('dideban-horizontal-timeline');

                didebanHorizontalTimeline.style.setProperty("--timelineColor", color);

                var first = true;
                response.data.statuses.forEach(function (time) {
                    jQuery("#dideban-timeline").append(createHorizontalTimeElement(time['time_day'], time['time_hour'], time['to_status'], first));
                    first = false;
                });
            }

            orderResponse.querySelector('[name="dideban_table_first_name"]').textContent = response.data.firstName;
            orderResponse.querySelector('[name="dideban_table_last_name"]').textContent = response.data.lastName;
            orderResponse.querySelector('[name="dideban_table_total"]').textContent = response.data.total + " تومان";
            orderResponse.querySelector('[name="dideban_table_address"]').textContent = response.data.address;
            orderResponse.querySelector('[name="dideban_table_status"]').textContent = response.data.status;
            if (response.data.post_barcode) {
                orderResponse.querySelector('[name="dideban-post-code"]').textContent = "";
                var url = "https://tracking.post.ir/?id=" + response.data.post_barcode;
                var aTag = jQuery("<a>", {
                    "href": url,
                    "target": "_blank",
                    "class": "dideban-postcode-btn"
                }).text("پیگیری از پست");
                jQuery(orderResponse.querySelector('[name="dideban-post-code"]')).append(aTag);
                orderResponse.querySelector('[name="dideban-post-code"]').classList.add('show');
                aTag.css("background", orderResponse.querySelector('[name="dideban-post-code"]').getAttribute("data-color"));
            } else {
                orderResponse.querySelector('[name="dideban-post-code"]').classList.remove('show');
            }

            orderResponse.classList.add('show');
            document.querySelector('#dideban-order-status-form').scrollIntoView({
                behavior: 'smooth'
            });
            orderForm.reset();
        });
    }

    orderForm.addEventListener('submit', function (e) {
        e.preventDefault();

        submitFrom();
    });

    var params = new URLSearchParams(window.location.search);
    var orderId = params.get('did');
    if (orderId) {
        var input = document.querySelector('input[name="code"]');
        if (input) {
            input.value = orderId;
            submitFrom();
        }
    }
});

function createTimeElement(datetime, status, color) {
    var path = jQuery("<path>", {
        "fill": "#FFFFFF",
        // <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
        // <!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license
        // (Commercial License) Copyright 2022 Fonticons, Inc. -->
        // <path d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372
        // 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z"/></svg>
        // "d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z",
        "d": "M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 " + "278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z"
    });
    var svg = '<svg class="svg-inline--fa fa-circle fa-w-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="#FFFFFF" d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z"/></svg>';
    var divTrackingIcon = jQuery("<div>", { "class": "tracking-icon status-delivered" }).append(svg);
    divTrackingIcon.css("background-color", color);
    // divTrackingIcon.style.setProperty("background-color",color, "important")
    var statusString = "وضعیت سفارش شما به ";
    statusString += status;
    statusString += " تغییر یافت.";
    var span = jQuery("<span>").text(datetime);

    // statusString += " <span> "
    // statusString += datetime
    // statusString += " </span> "
    var divTrackingDate = jQuery("<div>", { "class": "tracking-date" }).text(statusString).append(span);
    var divTrackingItem = jQuery("<div>", { "class": "tracking-item" }).append(divTrackingIcon).append(divTrackingDate);

    return divTrackingItem;
}

function createHorizontalTimeElement(date, time, status, first) {
    var svg = '<svg class="svg-inline--fa fa-circle fa-w-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="#FFFFFF" d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z"/></svg>';

    var spanDate = jQuery("<span>", {
        "class": "date"
    }).text(date);

    var spanTime = jQuery("<span>", {
        "class": "author"
    }).text(time);

    var divTimestamp = jQuery("<div>", { "class": "timestamp" }).append(spanDate).append(spanTime);

    var h6 = jQuery("<h6>").text(status);
    var divStatus = jQuery("<div>", { "class": "status" }).append(svg).append(h6);

    var li = jQuery("<li>", { "class": "li complete" });
    if (first) {
        // var span =  jQuery("<span>", { "class": "firstspan"});
        li.addClass("start-line");
        // li.append(span)
    }
    li.append(divTimestamp).append(divStatus);
    return li;
}

function resetMessages() {
    document.querySelectorAll('.field-msg').forEach(function (f) {
        return f.classList.remove('show');
    });
}

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

},{}]},{},[1]);
